import styled, { css } from 'styled-components'
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider'

export const Container = styled.h1<{
  $type: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h7'
  $weight: 'regular' | 'semibold' | 'bold'
}>`
  color: ${getAutomatedStyleProp('colorOnBackground', 'var(--text-primary)')};
  font-family: ${getAutomatedStyleProp('fontFamilyHeading', 'var(--font-family-heading)')};
  font-style: ${getAutomatedStyleProp('fontStyleHeading')};
  text-transform: ${getAutomatedStyleProp('textTransformHeading')};

  ${({ $type }) =>
    $type === 'h1' &&
    css`
      font-size: var(--font-size-800);
      line-height: var(--font-line-height-700);
      letter-spacing: var(--font-letter-spacing-densest);
    `};

  ${({ $type }) =>
    $type === 'h2' &&
    css`
      font-size: var(--font-size-700);
      line-height: var(--font-line-height-600);
      letter-spacing: var(--font-letter-spacing-densest);
    `};

  ${({ $type }) =>
    $type === 'h3' &&
    css`
      font-size: var(--font-size-600);
      line-height: var(--font-line-height-500);
      letter-spacing: var(--font-letter-spacing-denser);
    `};

  ${({ $type }) =>
    $type === 'h4' &&
    css`
      font-size: var(--font-size-500);
      line-height: var(--font-line-height-400);
      letter-spacing: var(--font-letter-spacing-denser);
    `};

  ${({ $type }) =>
    $type === 'h5' &&
    css`
      font-size: var(--font-size-400);
      line-height: var(--font-line-height-300);
      letter-spacing: var(--font-letter-spacing-dense);
    `};

  ${({ $type }) =>
    $type === 'h6' &&
    css`
      font-size: var(--font-size-300);
      line-height: var(--font-line-height-200);
      letter-spacing: var(--font-letter-spacing-normal);
    `};

  ${({ $type }) =>
    $type === 'h7' &&
    css`
      font-size: var(--font-size-200);
      line-height: var(--font-line-height-100);
      letter-spacing: var(--font-letter-spacing-denser);
    `};

  ${({ $weight }) =>
    $weight === 'regular' &&
    css`
      font-weight: ${getAutomatedStyleProp('fontWeightHeading', 'var(--font-weight-regular)')};
    `};

  ${({ $weight }) =>
    $weight === 'semibold' &&
    css`
      font-weight: ${getAutomatedStyleProp('fontWeightHeading', 'var(--font-weight-semibold)')};
    `};

  ${({ $weight }) =>
    $weight === 'bold' &&
    css`
      font-weight: ${getAutomatedStyleProp('fontWeightHeading', 'var(--font-weight-semibold)')};
    `};
`
